export default __webpack_public_path__ + "static/media/folder.7db9943c.svg";